module.exports = __webpack_public_path__ + "615e2f70ddb1cc9ccbfb54033aa89628.pdf";